// extracted by mini-css-extract-plugin
export default {"wrapper":"Qlj0R","title":"TgScU","description":"DjuPS","form":"cS7jR","phoneInput":"kvSNl","orderBackCallBtn":"VDLcU","reCaptcha":"JZGnh","textFail":"KkKGw"};